import React from "react";
import axios from "axios";
import * as crossfilter from "crossfilter2/crossfilter";
import "dc/dist/style/dc.css";
export const CXContext = React.createContext("CXContext");

export class DataContext extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, hasNDX: false };
  }

  componentDidMount() {
    if (this.state.hasNDX) {
      return;
    }
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true });

    axios
      .get("/Home/QueryProjectData")
      .then((res) => {
        
        this.ndx = crossfilter(res.data); //TODO possibly need to update this
        this.setState({ loading: false, hasNDX: true });
      })
      .then(() => {
        const loader = document.querySelector(".preloader");
        // console.log(loader);
        if (loader) {
          loader.classList.add("after-loader");
        }
      });
  }

  render() {
    if (!this.state.hasNDX) {
      return null;
    }
    return (
      <CXContext.Provider value={{ ndx: this.ndx }}>
        <div ref={this.parent}>{this.props.children}</div>
      </CXContext.Provider>
    );
  }
}
